<script setup lang="ts">
import NavbarMenuButtonTheme from '@/components/navbar/NavbarMenuButtonTheme.vue'
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import SkeletonBase from '@/components/skeleton/SkeletonBase.vue'

// stores
const appStore = useAppStore()

// computed
const loaded = computed(() => appStore.loaded)
</script>

<template>
  <navbar-menu-button-theme v-if="loaded"></navbar-menu-button-theme>
  <skeleton-base v-else width="9" height="9" rounded="full" color="stone"></skeleton-base>
</template>

<style scoped></style>
